import styled from '@emotion/styled'
import { typography, colors } from '@resiliatech/birdsong'

export const EmptyStateContainer = styled.div`
  align-items: center;
  background-color: ${colors.background.secondaryBackground};
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 16px 0;
  width: 100%;
`

export const Text = styled.div`
  ${typography.baseline.regularSans}
  max-width: 848px;
  text-align: center;
`
